import React from 'react'
import View from '../atoms/View'
import { RootReducer } from 'src/redux/rootReducer'
import { useDispatch, useSelector } from 'react-redux'
import SelectInput from '../atoms/SelectInput'
import { useTranslation } from 'react-i18next'
import { CLOSE_FILTER_MODAL, SET_FILTERS, TOGGLE_FILTER_MODAL } from 'dealer-reducers'
import DistanceFilter from '../atoms/DistanceFilter'
import Space from '../atoms/Space'
import Text from '../atoms/TextNew'
import MotorbikeFilters from './MotorbikeFilters'
import { BROWSE_ITEM_MAX_WIDTH } from './BrowseItem'
import CloseXSvg from '../other/svg/CloseXSvg'
import track from 'src/helpers/track'
import Button from '../atoms/Button'

const OfferFilters = ({ containerRef }: { containerRef: React.RefObject<HTMLDivElement> }): JSX.Element => {
  const currentTab = useSelector((state: RootReducer) => state.offersListReducer.tab)
  const itemsPerRowBase = Math.ceil((containerRef.current?.clientWidth ?? 1) / BROWSE_ITEM_MAX_WIDTH)
  const singleItemWidth = (containerRef.current?.clientWidth ?? 1) / itemsPerRowBase - 5
  const showFilters = useSelector((item: RootReducer) => item.tableToolsReducer.showFilterModal)
  const filters = useSelector((state: RootReducer) => state.tableToolsReducer.filters[currentTab])
  const { t } = useTranslation()
  const dispatch = useDispatch()

  return (
    <View
      style={{ width: `${singleItemWidth}px` }}
      className={`bg-groupBlue absolute z-10 top-[65px] right-0 rounded-b-4 transition-transform duration-500 px-16 ${
        showFilters ? 'translate-y-0' : 'translate-y-[-150%]'
      }`}>
      <View className="mx-auto max-w-[300px]">
        <View className="flex flex-col flex-1 h-full">
          <Space y={10} />
          <View className="flex items-end justify-end">
            <CloseXSvg
              className="flex justify-center items-center border border-white w-8 h-8 rounded-4 text-white cursor-pointer mr-[-35px]"
              svgStyles="w-3 h-3"
              onClick={() => {
                dispatch(CLOSE_FILTER_MODAL())
              }}
            />
          </View>
          <Space y={2} />
          <DistanceFilter
            zipCode={filters.zip_code}
            distance={filters.distance}
            onZipCodeChange={(val) => {
              dispatch(SET_FILTERS({ ...filters, zip_code: val, tab: currentTab }))
            }}
            onDistanceChange={(val) => {
              track('dealer_distance_range_click')
              dispatch(SET_FILTERS({ ...filters, distance: val as number, tab: currentTab }))
            }}
          />
        </View>
        <View className="flex flex-col flex-1">
          <Space y={6} />
          <Text className="ml-4 text-xl font-SemiBold text-white">{t('filter_modal.vehicle').toUpperCase()}</Text>
          <Space y={2} />
          <SelectInput
            label={t('filter_modal.damaged_label')}
            value={filters.damaged}
            options={[
              { optionVal: true, optionLabel: t('filter_modal.damaged') },
              {
                optionVal: false,
                optionLabel: t('filter_modal.not_damaged')
              }
            ]}
            onChange={(val) => {
              dispatch(SET_FILTERS({ ...filters, damaged: val === '' ? val : Boolean(val), tab: currentTab }))
            }}
          />
          <Space y={2} />
          <MotorbikeFilters showFilter={filters.vehicle_type === 'Motorbike'} />
          <div className="h-4" />
          <Button
            color="lightBlue"
            variant="medium"
            onClick={() => {
              dispatch(TOGGLE_FILTER_MODAL())
            }}>
            {t('filter_modal.filter_button')}
          </Button>
          <div className="h-4" />
          <div className="h-4" />
        </View>
      </View>
    </View>
  )
}

export default OfferFilters
